import { render, staticRenderFns } from "./GroupOrders.vue?vue&type=template&id=4090f3b8&"
import script from "./GroupOrders.vue?vue&type=script&lang=js&"
export * from "./GroupOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports